import { ElevesView } from '@teetsh/app/src/types/eleves';
import _omit from 'lodash-es/omit';
import { SortingState } from '@tanstack/react-table';

export function sortFieldsToEleveViewFields(
  view: ElevesView,
  fieldsInOrder: SortingState,
): ElevesView {
  return {
    ...view,
    fields: view.fields.map(f => {
      const matchingField = fieldsInOrder.find(ff => ff.id === f.id);
      if (matchingField) {
        return {
          ...f,
          sort: {
            priority: 1,
            direction: matchingField.desc ? 'DESC' : 'ASC',
          },
        };
      }
      return _omit(f, 'sort');
    }),
  };
}
